module.exports = __webpack_public_path__ + "static/app-shot-n-1-1-173dcb6cc43768d51f3f9aded0abf84b.png";